import { COVERGO_SAAS_PROD } from "../consts.js"

export const oldmutualkenya = {
	"oldmutualkenya-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "oldmutualkenya_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_PROD
	}
}
